// components/Home/MiniBarChart.tsx
"use client";

import { CMSModal } from "@/context";
import { Tooltip } from "antd";
import moment from "moment";
import React, { useContext } from "react";

interface MiniBarChartProps {
  data: number[];
}

const MiniBarChart: React.FC<MiniBarChartProps> = ({ data }) => {
  const { theme } = useContext(CMSModal);
  const max = Math.max(...data, 1);
  const isDark = theme === "dark";
  const CHART_HEIGHT = 64;

  const dayLabels = Array.from({ length: 7 }, (_, i) => {
    const d = moment().subtract(6 - i, "days");
    return i === 6 ? "Today" : d.format("ddd");
  });

  return (
    <div className="relative w-full">
      {/* Bars */}
      <div
        className="flex gap-1.5 w-full items-end"
        style={{ height: `${CHART_HEIGHT}px` }}
      >
        {data.map((val, i) => {
          const isToday = i === data.length - 1;
          const heightPx =
            val > 0 ? Math.max((val / max) * CHART_HEIGHT, 8) : 3;

          return (
            <Tooltip
              key={i}
              title={
                <div className="flex flex-col items-center">
                  <span className="font-semibold">{dayLabels[i]}: {val}</span>
                </div>
              }
              color="#099ed1"
              placement="top"
            >
              <div className="flex-1 flex items-end cursor-pointer">
                <div
                  className="w-full rounded-t-sm transition-all duration-500"
                  style={{
                    height: `${heightPx}px`,
                    background: isToday
                      ? isDark
                        ? "rgba(9,158,209,0.8)"
                        : "rgba(9,158,209,0.6)"
                      : isDark
                        ? "rgba(9,158,209,0.45)"
                        : "rgba(9,158,209,0.3)",
                    border: "1px solid rgba(9,158,209,0.5)",
                  }}
                />
              </div>
            </Tooltip>
          );
        })}
      </div>

      {/* Day Labels */}
      <div className="flex gap-1.5 w-full mt-1">
        {dayLabels.map((label, i) => (
          <div
            key={i}
            className={`flex-1 text-center text-[9px] truncate ${
              i === 6
                ? "text-[#099ed1] font-semibold"
                : isDark
                  ? "text-gray-500"
                  : "text-gray-400"
            }`}
          >
            {label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MiniBarChart;
